<template>
  <div class="purchase-detail contant-wrap">
    <h4 class="common-title">出库详情</h4>
    <div class="filter-data">
      <div class="filter-control">
        <div class="row">
          <el-row :gutter="24">
            <el-col :span="8">
              <label class="filter-label" for="">出库日期：</label><span>{{form.createDate | dateFilter}}</span>
            </el-col>
            <el-col :span="8">
              <label class="filter-label" for="">出库类型：</label><span>{{typeStr(form.instockType)}}</span>
            </el-col>
            <el-col :span="8">
              <label class="filter-label" for="">出库金额：</label><span>{{form.totalPrice}}</span>
            </el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row :gutter="24">
            <el-col :span="8">
              <label class="filter-label" for="">制单人：</label><span>{{form.creater}}</span>
            </el-col>
            <el-col :span="8">
              <label class="filter-label" for="">确认人：</label><span>{{form.confirmer}}</span>
            </el-col>
            <el-col :span="8">
              <label class="filter-label" for="">备注：</label><span>{{form.remark}}</span>
            </el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-button type="success" class="button" @click="fileExport">导出</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- table -->
    <div class="table">
      <el-table
        :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="drugName"
          label="药品名"
          width="">
        </el-table-column>
        <el-table-column
          prop="specification"
          label="药品规格"
          width="">
        </el-table-column>
        <el-table-column
          prop="manufacturer"
          label="厂家"
          width="">
        </el-table-column>
        <el-table-column
          prop="approvalNumber"
          label="批准文号"
          width="">
        </el-table-column>
        <el-table-column
          prop="instockCount"
          label="出库数量"
          width="">
          <template slot-scope="scope">
            {{scope.row.instockCount}}{{scope.row.instockUnit}}
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="进货价"
          width="180">
          <template slot-scope="scope">
            {{scope.row.purchasePrice}}元/{{scope.row.instockUnit}}
          </template>
        </el-table-column>
        <el-table-column
          prop="salePrice"
          label="零售价"
          width="180">
        </el-table-column>
        <el-table-column
          prop="drugBatchNo"
          label="批号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="validityDate"
          label="有效期"
          align="center"
          width="180">
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="tableData.length > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="query.currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- footer -->
    <footer-control>
      <template slot="right">
        <el-button type="primary" plain class="button" @click="goBack">返回</el-button>
      </template>
    </footer-control>
    <div class="space-empty"></div>
  </div>
</template>
<script>
import FooterControl from '@/components/FooterControl.vue';
import { pageSizes } from '@/config/constant';
import { log } from 'util';

export default {
  name: '',
  components: { FooterControl },
  data() {
    return {
      value: '',
      input5: '',
      options: [],
      selectTableOptions: [],
      tableData: [],
      form: {
        supplier: '',
        remark: '',
        createDate: '',
        batchInstockId: '',
      },
      query: {
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      total: 0, // 总数据条数
      pageSizes,
      options1: [{
        value: 1,
        label: '采购退货',
      }, {
        value: 6,
        label: '调拨出库',
      }, {
        value: 7,
        label: '报损出库',
      }, {
        value: 8,
        label: '其他出库',
      }],
    };
  },
  methods: {
    typeStr(val) {
      const item = this.options1.find(res => res.value == val);
      if (item) {
        return item.label;
      }
      return '';
    },
    // 每页展示数据条数变更
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(e) {
      this.query.currentPage = e;
      this.getTableData();
    },
    getTableCol() {},
    // 批次详情信息
    getDetailInfo() {
      const { id } = this.$route.params;
      this.$api.drugControl.detailInfo({ batchInstockId: id })
        .then((res) => {
          this.form.createDate = res.createDate;
          this.form.remark = res.remark;
          this.form.supplier = res.supplier;
          this.form.creater = res.creater;
          this.form.confirmer = res.confirmer;
          this.form.rootId = res.rootId;
          this.form.instockType = res.instockType;
          this.form.rootBatchNo = res.rootBatchNo;
          this.form.totalPrice = res.totalPrice;
          this.getTableData();
        });
    },
    // 批次详情列表-分页
    getTableData(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      const { id } = this.$route.params;
      this.$api.drugControl.detailList({ batchInstockId: id, ...this.query })
        .then((res) => {
          this.tableData = res.list.map((item) => {
            return {
              ...item,
              drugSalePrice: item.salePrice,
            };
          });
          this.total = res.totalSize;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    toHistory() {
      this.$router.push({
        name: 'purchaseDetail',
        query: {
          id: this.form.rootId,
          state: 'detail',
        },
      });
    },
    // 导出详情
    fileExport() {
      const { id } = this.$route.params;
      this.$api.drugControl.batchDetailExport({
        batchInstockId: id,
      });
    },
  },
  filters: {
    dateFilter(val) {
      return val.slice(0, 10);
    }
  },
  mounted() {
    this.getDetailInfo();
  },
};
</script>

<style lang="scss" scoped>
 .input {
   display: inline-block;
    width: 80px;
    margin-right: 10px;
 }
</style>
